export function initYmaps() {
	const mapElements = document.querySelectorAll('.js-ymap');
	const mapApiKey = '';
	let mapApiLoaded = false;
	const initializedMaps = new WeakSet();

	function createMap(element) {
		if (initializedMaps.has(element)) return;
		initializedMaps.add(element);

		const coordsAttr = element.dataset.ymapCoords || '59.941740, 30.351629';
		const hintContent = element.dataset.ymapHint || 'Офис в Санкт-Петербурге';
		const coords = coordsAttr.split(',').map(Number);

		const ymaps = window.ymaps;
		const map = new ymaps.Map(element, {
			center: coords,
			zoom: 17,
			controls: ['zoomControl'],
		});

		const geoObject = new ymaps.GeoObject(
			{
				geometry: {
					type: 'Point',
					coordinates: coords,
				},
				properties: {
					hintContent,
				},
			},
			{
				preset: 'islands#blueCircleDotIcon',
			},
		);

		map.geoObjects.add(geoObject);
	}

	function loadYmaps(callback) {
		if (mapApiLoaded) {
			if (window.ymaps) {
				window.ymaps.ready(callback);
			} else {
				const checkInterval = setInterval(() => {
					if (window.ymaps) {
						clearInterval(checkInterval);
						window.ymaps.ready(callback);
					}
				}, 300);
			}
			return;
		}

		mapApiLoaded = true;

		const script = document.createElement('script');
		script.src = `https://api-maps.yandex.ru/2.1/?apikey=${mapApiKey}&lang=ru_RU`;
		script.async = true;
		script.onload = () => window.ymaps.ready(callback);
		document.head.appendChild(script);
	}

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					const element = entry.target;
					loadYmaps(() => createMap(element));
					observer.unobserve(element);
				}
			});
		},
		{ threshold: 0.2 },
	);

	mapElements.forEach((el) => observer.observe(el));
}
